export default __webpack_public_path__ + "static/media/logo-indicadores-justiciacriminal.b840a1b2.svg";